import { useContext, useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import { useSelector } from "react-redux";
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import validateInputArray from '../functions/validateInputArray';
import removeStrCommas from '../functions/removeStrCommas';
import percentToDecimal from '../functions/percentToDecimal';
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const AddGroupRebateSetup = () => {
    // get page context from parent
    const {
        addGroupRebateSetupModal,
        setAddGroupRebateSetupModal,
        snackbarAlert,
        getRefreshData,
        groupSetupInputConfig,
        rebateSetupInputLists,
        rebateInputTypeId,
    } = useContext(PageContext);
    // get HTTP context from parent
    const {
        POST,
    } = useContext(HttpContext);
    // get global redux state 
    const consortiumId = useSelector((state) => state.consortiumId);
    // initialize state 
    const [values, setValues] = useState({});
    const [config, setConfig] = useState([]);
    const [error, setError] = useState([{}]);

    // function to transform rebate inputs 
    const transformRebateSetup = (row) => {
        let temp = row;
        // remove commas from spend fields 
        temp['minspend'] = removeStrCommas(temp['minspend']);
        temp['maxspend'] = removeStrCommas(temp['maxspend']);
        // pick ids for each dropdown field
        temp['rebatesetuptypeid'] = temp['rebatesetuptypeid']['id'];
        temp['producttypeid'] = temp['producttypeid']['id'];
        temp['feecategoryid'] = temp['feecategoryid']['id'];
        temp['billingrateid'] = temp['billingrateid']['id'];
        // transform rate based on input type 
        // run transformation on incentive rates depending on rebate input type id (id of 0 is default and does not require transformation)
        if (rebateInputTypeId == 1 && temp['incentiverate'] != null) {
            // id == 1 for input as percent transformed to decimal 
            temp['incentiverate'] = percentToDecimal(temp['incentiverate']);
        }
        // return transformed row 
        return temp;
    }

    // event handler for submit click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            let requestValues = [{ ...values }];
            // validate input
            let checkError = validateInputArray(
                requestValues,
                groupSetupInputConfig,
                dynamicValidation,
                rebateSetupInputLists,
                snackbarAlert,
                error,
                setError,
                dynamicTransformation,
                {
                    incentiverate: {
                        rateTypeId: rebateInputTypeId,
                    }
                },
            );
            // exit request if error 
            if (checkError) {
                reject();
                return;
            }
            // use POST function to make request 
            POST('/consortium/groupRebateSetups', {
                consortiumid: consortiumId,
                ...requestValues[0],
            }).then(res => {
                console.log(res);
                // default values 
                let temp = {
                    ...values,
                }
                temp['minspend'] = '';
                temp['maxspend'] = '';
                temp['incentiverate'] = '';
                setValues(values => values = temp);
                // show snackbar on success
                snackbarAlert(true, 'Successfully added rebate setup.', 'success');
                // hide modal
                setAddGroupRebateSetupModal(addGroupRebateSetupModal => addGroupRebateSetupModal = false);
                // refresh data 
                return getRefreshData();
            }).then(res => {
                // reject on success
                resolve(res);
            }).catch(err => {
                console.log(err);
                // show snackbar on failure
                snackbarAlert(true, 'Error adding rebate setup.', 'error');
                // reject on error
                reject(err);
            });
        });
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (groupSetupInputConfig) {
            setConfig(config => config = groupSetupInputConfig);
        }
    }, [groupSetupInputConfig]);

    return (
        <>
            <CCOffcanvas
                title={`Add Group Rebate Setup`}
                show={addGroupRebateSetupModal}
                onCanvasClose={() => setAddGroupRebateSetupModal(addGroupRebateSetupModal => addGroupRebateSetupModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3"
                offCanvasClassName="offcanvas-parent-card-30"
            >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {/* map DynamicPageInput over all elements of input config */}
                        {config.map((el) =>
                            <>
                                <div >
                                    <DynamicPageInput data={values} setData={setValues} config={el} args={rebateSetupInputLists} width={'100%'} topAlignTypography={true} />
                                </div>
                            </>
                        )}
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"}
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                            onButtonClick={() => setAddGroupRebateSetupModal(addGroupRebateSetupModal => addGroupRebateSetupModal = false)}
                        />
                        {/* button to submit company entitlement edit */}
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default AddGroupRebateSetup; 